export default __webpack_public_path__ + "static/media/LabDiagnosticsIcon.fd3a5d4f.svg";